import { render } from "./RenameModuleModal.vue?vue&type=template&id=0d55822e&scoped=true&ts=true"
import script from "./RenameModuleModal.vue?vue&type=script&lang=ts"
export * from "./RenameModuleModal.vue?vue&type=script&lang=ts"

import "./RenameModuleModal.vue?vue&type=style&index=0&id=0d55822e&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d55822e"]])

export default __exports__